<script setup>
const { currentArticle, markAsRead } = defineProps({
	currentArticle: {
		type: Object,
		required: true,
	},
	markAsRead: {
		type: Function,
		required: true,
	}
});
</script>

<template>
<section class="no-embed dialog">
	<h1>Article opens in a new tab</h1>
	<p>{{currentArticle?.source}} doesn&#8217;t allow their content to be embedded, but we still think the article is worth reading.</p>
	<p>You can access this article directly by going to the source.</p>
	<a
		class="btn"
		target="_blank"
		:href="currentArticle?.url"
		@click.stop="markAsRead(currentArticle?.id, true)"
	>Open in new tab</a>
</section>
</template>

<style lang="scss" scoped>
.dialog {
	background-color: var(--bg2);
	border: 1px solid var(--border);
	border-radius: 32px;
	box-shadow: 0 22px 49px -10px rgba(0, 0, 0, 0.03), 0 43px 60px -30px rgba(0, 0, 0, 0.06), 0 59px 41px -47px rgba(0, 0, 0, 0.05);

	padding: 24px 20px 20px;
	position: relative;
	width: clamp(220px, 70%, 500px);

	margin-top: 40px;
	margin-bottom: 10vh; // fallback
	margin-bottom: 10dvh;
}
h1 { margin: 0; }
p { margin: .75em 0; }
.btn:last-child {
	margin-top: 4px;
	border-bottom-left-radius: 12px;
}
</style>
